interface SaveBarProps {
  saving: boolean;
  saveSuccess: boolean;
  saveError: string;
  onSave: () => void;
}

export default function SaveBar({ saving, saveSuccess, saveError, onSave }: SaveBarProps) {
  return (
    <div className="pt-3 border-t" style={{ borderColor: 'var(--dash-border-light)' }}>
      {saveError && (
        <div className="border border-red-500/30 bg-red-500/10 rounded px-4 py-2.5 mb-3">
          <p className="font-sans text-sm text-red-300">{saveError}</p>
        </div>
      )}
      <div className="flex items-center gap-3">
        <button
          onClick={onSave}
          disabled={saving}
          className="bg-blue-600 text-white font-mono text-sm font-medium px-5 py-2 rounded hover:bg-blue-500 transition-colors disabled:opacity-50 uppercase tracking-wider"
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
        {saveSuccess && (
          <span className="flex items-center gap-1.5 font-sans text-sm text-emerald-400">
            <span className="text-xs">&#10003;</span> Saved
          </span>
        )}
      </div>
    </div>
  );
}
